
import "../css/components/TopBarImage.css"

export default function TopBarImage(){

    return <div className="topBarContainer">
        <img src="/assets/shared/topbar.png" />
    </div>
}